import React from "react";

import PaymentsLinkingContent from "../components/payments-linking/payments-linking-content.js";

const PaymentsLinking = () => {
  return <PaymentsLinkingContent />;
};

export default PaymentsLinking;
